import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ConfirmationService, Message, TreeNode } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { Permissao } from 'src/app/admihair/api/dto/permissao';
import { CategoriaPermissao } from 'src/app/admihair/api/dto/categoria-permissao';
import { CategoriaPermissaoService } from 'src/app/admihair/service/categoria-permissao.service';
import { CategoriaPermissaoAgrupada } from 'src/app/admihair/api/dto/categoria-permissao-agrupada';
import { TreeTable } from 'primeng/treetable';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { UsuarioPermissaoAdministradoraService } from 'src/app/admihair/service/usuario-permissao-administradora.service';
import { UsuarioPermissaoAdministradoraRequest } from 'src/app/admihair/api/dto/usuario-permissao-administradora-request';
import { ActivatedRoute } from '@angular/router';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';


@Component({
  selector: 'app-usuario-franquia-editar',
  templateUrl: './usuario-franquia-editar.component.html',
  styleUrls: ['./usuario-franquia-editar.component.scss']
})
export class UsuarioFranquiaEditarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;

  loadingGeral: boolean = false;
  loadingTable: boolean = false;
  usuarioId?: number;
  administradoraId?: number;

  usuario?: Usuario;
  emailConsulta?: string;
  cpfConsulta?: string;
  tiposBusca: string[] = ['CPF', 'E-mail'];
  buscaSelecionada: string = 'E-mail';

  exibirDialogPermissao: boolean = false;
  exibirSpinnerDialog: boolean = false;
  progressoRequisicao: boolean = false;

  colunasTreeTableDialog: any[] = [];
  categoriasTreeTableDialog: TreeNode[] = [];
  categoriasTreeTableDialogSelecionada: TreeNode[] = [];

  colunasTreeTableSalvas: any[] = [];
  categoriasTreeTableSalvas: TreeNode[] = [];
  categoriasTreeTableSalvasSelecionada: TreeNode[] = [];

  categoriasPermissaoAgrupadaBackend: CategoriaPermissaoAgrupada[] = [];

  constructor(private usuarioService: UsuarioService,
    private categoriaPermissaoService: CategoriaPermissaoService,
    private usuarioPermissaoAdministradoraService: UsuarioPermissaoAdministradoraService,
    private _activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    storageService: UtilStorageService
  ) { super(erroService, storageService) }

  ngOnInit(): void {
    this.loadingGeral = true;
    this.carregarId();
    this.administradoraId = this.getAdministradora().id;
    this.inicializarColunas();
    this.carregarUsuarioPorId();
  }

  carregarId() {
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if (idParam) {
      this.usuarioId = parseInt(idParam);
    }
  }

  inicializarColunas() {
    this.colunasTreeTableDialog = [
      { field: 'descricao', header: 'Permissão' }
    ];
    this.colunasTreeTableSalvas = [
      { field: 'descricao', header: 'Permissão' }
    ];
  }


  carregarUsuarioPorId() {
    this.usuarioService.buscarPorId(this.usuarioId).subscribe({
      next: (data: Usuario) => {
        this.usuario = data;
        this.messagemVisivel = false;
        this.listarCategoriasSalvas();
        this.loadingGeral = false;
      },
      error: (err: any) => {
        this.loadingGeral = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  atualizarPermissoes() {
    this.progressoRequisicao = true;

    const permissoes = this.obterPermissoesDaTree(this.categoriasTreeTableSalvas);
    const permissoesId = this.obterPermissoesIds(permissoes);

    const usuarioPerm: UsuarioPermissaoAdministradoraRequest = {
      administradoraId: this.administradoraId,
      usuarioId: this.usuario?.id,
      permissoesId: permissoesId
    }

    this.usuarioPermissaoAdministradoraService.atualizarPermissoes(usuarioPerm).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    })

  }

  listarCategoriasSalvas() {
    this.loadingTable = true;
    this.categoriaPermissaoService.listarAdicionadasPorUsuarioETipoFranquia(this.administradoraId, this.usuario?.id).subscribe({
      next: (data: CategoriaPermissaoAgrupada[]) => {
        this.categoriasTreeTableSalvas = this.converterParaTreeNode(data);
        this.categoriasPermissaoAgrupadaBackend = data;
        this.loadingTable = false;
      },
      error: (err: any) => {
        this.loadingTable = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  listarCategoriasPermissoesDisponiveis() {
    this.exibirSpinnerDialog = true;
    this.categoriaPermissaoService.listarNaoAdicionadasPorUsuarioETipoFranquia(this.administradoraId, this.usuarioId).subscribe({
      next: (data: CategoriaPermissaoAgrupada[]) => {
        this.exibirSpinnerDialog = false;
        this.categoriasTreeTableDialog = this.converterParaTreeNode(data)
      },
      error: (err: any) => {
        this.exibirSpinnerDialog = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  adicionarPermissao() {

    this.categoriasTreeTableSalvas = this.converterParaTreeNode(this.categoriasPermissaoAgrupadaBackend);

    let permissoes: Permissao[] = [];
    for (const item of this.categoriasTreeTableDialogSelecionada) {
      if (!item.children) {
        if (!permissoes.some(perm => perm.id === item.data.id)) {
          permissoes.push(item.data)
        }
      }
    }

    for (const item of this.categoriasTreeTableSalvas) {
      if (item.children) {
        let filhos = item.children;
        for (const itemFilho of filhos) {
          if (!permissoes.some(perm => perm.id === itemFilho.data.id)) {
            permissoes.push(itemFilho.data)
          }
        }
      }
    }

    let categoriaAgrupadas = this.extrairCategoriaPermissaoAgrupadoDeTreeTable(permissoes);
    this.categoriasTreeTableSalvas = this.converterParaTreeNode(categoriaAgrupadas);
    this.exibirDialogPermissao = false;

  }

  extrairCategoriaPermissaoAgrupadoDeTreeTable(listaPermissoes?: Permissao[]): CategoriaPermissaoAgrupada[] {
    if (listaPermissoes) {
      let categoriasPermissoes: CategoriaPermissao[] = [];
      for (const perm of listaPermissoes) {
        if (perm.categoriaPermissao) {
          if (!categoriasPermissoes.some(categoria => categoria.id === perm.categoriaPermissao?.id)) {
            categoriasPermissoes.push(perm.categoriaPermissao);
          }
        }
      }
      let categoriasPermissoesAgrupadas: CategoriaPermissaoAgrupada[] = [];

      for (const item of categoriasPermissoes) {
        let permissoesList: Permissao[] = [];
        for (const itemPerm of listaPermissoes) {
          if (itemPerm.categoriaPermissao?.id === item.id) {
            permissoesList.push(itemPerm);
          }
        }
        let categoriaPermissaoAgrupadaItem: CategoriaPermissaoAgrupada = {
          id: item.id,
          descricao: item.descricao,
          permissoes: permissoesList
        }
        categoriasPermissoesAgrupadas.push(categoriaPermissaoAgrupadaItem);
      }

      return categoriasPermissoesAgrupadas;
    }
    return [];
  }

  extrairPermissoesDeTree(listaTree?: TreeNode[]) {
    let permissoes: Permissao[] = [];
    if (listaTree) {
      for (const item of listaTree) {
        if (!item.children) {
          if (!permissoes.some(perm => perm.id === item.data.id)) {
            permissoes.push(item.data)
          }
        }
      }
    }
    return permissoes;
  }

  excluir() {
    const permissoes: Permissao[] = this.extrairPermissoesDeTree(this.categoriasTreeTableSalvasSelecionada);
    const permissoesIdExcluir: number[] = [];
    for (const item of permissoes) {
      if (item.id) {
        permissoesIdExcluir.push(item.id);
      }
    }

    const usuarioPermExcluirRequest: UsuarioPermissaoAdministradoraRequest = {
      administradoraId: this.administradoraId,
      usuarioId: this.usuario?.id,
      permissoesId: permissoesIdExcluir
    }

    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.loadingTable = true;
        this.usuarioPermissaoAdministradoraService.excluirListaPermissoes(usuarioPermExcluirRequest).subscribe({
          next: () => {
            this.listarCategoriasSalvas();
            this.exibirMensagemSucesso();
          },
          error: (err: any) => {
            this.loadingTable = false;
            this.exibirMensagemErro(err);
          }
        })
      }
    });
  }

  converterParaTreeNode(categorias: CategoriaPermissaoAgrupada[]): TreeNode[] {
    return categorias.map(categoria => ({
      data: categoria,
      children: categoria.permissoes ? categoria.permissoes.map(permissao => ({
        data: permissao,
        leaf: true
      })) : []
    }));
  }

  abrirDialogPermissao() {
    this.exibirDialogPermissao = true;
    this.listarCategoriasPermissoesDisponiveis();
  }

  buscar(table: TreeTable, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

   limpar(table: TreeTable) {
    table.filterGlobal('', 'contains');
    this.filter.nativeElement.value = '';
  }

  obterPermissoesDaTree(tree: TreeNode[]): Permissao[] {
    return tree
    .flatMap(
      node => node.children?.map(child => child.data as Permissao) ?? []
    );
  }

  obterPermissoesIds(permissoes: Permissao[]): number[] {
    return permissoes
    .map(p => p.id)
    .filter(id => id !== undefined) as number[];
  }
}
